import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Local celebrity selection state only. The celebrity roster itself is
 * server-backed (`@pushup/types`), so admins' changes reach every user; we
 * merely remember which opponent this device prefers.
 */
export interface CelebrityStoreState {
  selectedCelebrityId: string | null;
  selectCelebrity: (id: string | null) => void;
}

export const useCelebrityStore = create<CelebrityStoreState>()(
  persist(
    (set) => ({
      selectedCelebrityId: null,
      selectCelebrity: (id) => set({ selectedCelebrityId: id }),
    }),
    {
      name: "pushup-celebrities",
      partialize: (state) => ({ selectedCelebrityId: state.selectedCelebrityId }),
    },
  ),
);
